const permissions = {
  // candidate permissions
  candidateCreate: 'candidates:create',
  candidateReadAll: 'candidates:read_all',
  candidateHistory: 'candidates:view_history',
  candidateRequestDocument: 'candidates:request_document',

  candidateReadBasicInfo: 'candidates:read_basic_info',
  candidateReadBasicSkills: 'candidates:read_basic_skills',
  candidateReadExtendedInfo: 'candidates:read_extended_info',
  candidateReadResume: 'candidates:read_resume',
  candidateReadDocuments: 'candidates:read_documents',
  candidateReadHistory: 'candidates:read_history',
  candidateReadEmailHistory: 'candidates:read_email_history',
  candidateReadArchive: 'candidates:read_archive',
  candidateReadInsights: 'candidates:read_insights',
  candidateSendEmail: 'candidates:send_email',
  candidateRead: 'candidates:read',
  candidateUpdate: 'candidates:update',
  candidateReadBlacklisted: 'candidates:read_blacklisted',

  // application permissions
  applicationUpdate: 'applications:update',
  applicationSalaryRead: 'applications:read_salary',
  applicationSalaryUpdate: 'applications:update_salary',
  applicationNoticeRead: 'applications:read_notice',
  applicationTrackerRead: 'applications:read_tracker',
  applicationReject: 'applications:reject',
  applicationMoveStageConfirmation: 'applications:move_stage_confirmation',
  applicationMoveStageSendNotifications: 'applications:move_stage_send_notifications',
  applicationReadStatus: "applications:read_status",

  // is not mentioned
  applicationCreate: 'applications:create',
  applicationReadAll: 'applications:read_all',

  // position permissions
  positionCreate: 'positions:create',
  positionUpdate: 'positions:update',
  positionPublish: 'positions:publish',
  positionReadAll: 'positions:read_all',
  positionRead: 'positions:read',
  positionRequestDocument: 'positions:request_document',
  positionAssignRecruiters: 'positions:assign_recruiters',

  // notes permissions
  notesCreate: 'notes:create',
  notesReadAll: 'notes:read_all',

  // interview permissions
  interviewCreate: 'interviews:create',
  interviewReadAll: 'interviews:read_all',
  interviewEvaluationRead: 'interviews:read_evaluation',
  interviewEvaluationUpdate: 'interviews:update_evaluation',

  // company permissions
  companyTemplate: 'company:template',

  // company dashboard
  companyDashboard: 'company:dashboard',
  companyRead: 'company:read',
  companyUpdate: 'company:update',
  companyCareerSite: 'company:career_site',
  companyAccessKeys: 'company:access_keys',

  roleCreate: 'roles:create',
  roleReadAll: 'roles:read_all',
  roleUpdate: 'roles:update',
  roleDelete: 'roles:delete',

  // user permissions
  userCreate: 'users:create',
  userReadAll: 'users:read_all',
  userUpdate: 'users:update',
  userDelete: 'users:delete',
  userPersonalCalendar: 'users:personal_calendar',

  // reports
  reportsSourcing: 'reports:sourcing',
  reportsInterviewSchedule: 'reports:interview_schedule',

  // requisition permissions
  requisitionsCreate: 'requisitions:create',
  requisitionsReadAll: 'requisitions:read_all',
  requisitionsRead: 'requisitions:read',
  requisitionsDecision: 'requisitions:decision',
  requisitionsReadHistory: 'requisitions:read_history',
  requisitionsReadIncoming: 'requisitions:read_incoming',

  // job requests permissions
  jobRequestsRead: 'job_requests:read',
  jobRequestsApprove: 'job_requests:approve',
  jobRequestsClose: 'job_requests:close',
  jobRequestsReopen: 'job_requests:reopen',

  // evaluation forms permissions
  evaluationFormsReadAll: 'evaluation_forms:read_all',

  // recommended applications permissions
  recommendedApplicationsReadAll: 'recommended_applications:read_all',
  recommendedApplicationsCreate: 'recommended_applications:create',
  recommendedApplicationsUpdate: 'recommended_applications:update',
  recommendedApplicationsDelete: 'recommended_applications:delete',
  recommendedApplicationsDelete: 'recommended_applications:delete',
  recommendedApplicationsChangeScore: "recommended_applications:change_score",

  // subscription permissions
  subscriptionRead: 'subscription:read',
  subscriptionChange: 'subscription:change',
  subscriptionCancel: 'subscription:cancel',
  subscriptionPaymentRead: 'subscription:payment_read',

  // question permissions
  questionCreate: 'questions:create',
  questionUpdate: 'questions:update',
  questionReadAll: 'questions:read_all',

  // organization permissions
  organizationReadAll: 'organizations:read_all',
  organizationRead: 'organizations:read',
  organizationCreate: 'organizations:create',
  organizationUpdate: 'organizations:update',
  organizationUserRead: 'organizations:user_read',
  organizationUserCreate: 'organizations:user_create',
  organizationUserUpdate: 'organizations:user_update',
  organizationAssignUsers: 'organizations:assign_users',

  // org chart position permissions
  workforcePositionReadAll: 'workforce_position:read_all',
  workforcePositionReadSubtree: 'workforce_position:read_subtree',
  workforcePositionRead: 'workforce_position:read',
  workforcePositionCreate: 'workforce_position:create',
  workforcePositionUpdate: 'workforce_position:update',
  workforcePositionDelete: 'workforce_position:delete',
  workforcePositionReadMatrixManager: 'workforce_position:read_matrix_manager',
  workforcePositionReadMovePositions: 'workforce_position:read_move_positions',
  workforcePositionMoveBranch: 'workforce_position:move_branch',
  workforcePositionCreateRequisition: "workforce_position:create_requisition",

  // org chart employee permissions
  workforceEmployeeRead: 'workforce_employee:read',
  workforceEmployeeCreate: 'workforce_employee:create',
  workforceEmployeeUpdate: 'workforce_employee:update',
  workforceEmployeeDelete: 'workforce_employee:delete',
  workforceEmployeeAssignAsMatrixManager: 'workforce_employee:assign_as_matrix_manager',
  workforceEmployeeAddMatrixManager: 'workforce_employee:add_matrix_manager',
  workforceEmployeeReadJustFullnameAndEmail: "workforce_employee:read_just_fullname_and_email",

  // offer permissions
  offerApproversUpsert: "offers:upsert_approvers",
  offerCreate: "offers:create",
  offerRead: "offers:read",

   // data management permissions
  dataManagementRead: "data_management:read",
}

export default permissions

export const defaultRoleTypes = [
  {
    value: 'administrator',
    en: 'Administrator',
    ar: 'مسؤول',
    gr: 'Administrator',
  },
  {
    value: 'hr_manager',
    en: 'HR Manager',
    ar: 'مدير الموارد البشرية',
    gr: 'HR-Manager',
  },
  {
    value: 'recruiter',
    en: 'Recruiter',
    ar: 'مسؤول توظيف',
    gr: 'Recruiter',
  },
  {
    value: 'hiring_manager',
    en: 'Hiring Manager',
    ar: 'مدير التوظيف',
    gr: 'Einstellungsmanager',
  },
  {
    value: 'new',
    en: 'None',
    ar: 'بدون',
    gr: 'Keine',
  },
]

export const organizationRoleTypes = [
  {
    value: 'organization_administrator',
    en: 'Administrator',
    ar: 'مسؤول',
    gr: 'Administrator',
  },
  {
    value: 'organization_hr_manager',
    en: 'HR Manager',
    ar: 'مدير الموارد البشرية',
    gr: 'HR-Manager',
  },
  {
    value: 'organization_recruiter',
    en: 'Recruiter',
    ar: 'مسؤول توظيف',
    gr: 'Recruiter',
  },
  {
    value: 'organization_hiring_manager',
    en: 'Hiring Manager',
    ar: 'مدير التوظيف',
    gr: 'Einstellungsmanager',
  },
  {
    value: 'organization_user',
    en: 'Organization User',
    ar: 'مستخدم المنظمة',
    gr: 'Organisationsbenutzer',
  },
  {
    value: 'new',
    en: 'None',
    ar: 'بدون',
    gr: 'Keine',
  },
]
